/* eslint-disable no-empty-pattern */
import axios from "~axios"

const state = {
    scores: 0,
    gamification: {
        status: {
            options: {},
            lists: []
        },
        ratings: {
            is_enabled: false,
            lists: []
        },
        competitions: {
            lists: []
        },
        rewards: {
            options: {},
            lists: []
        }
    },
    folders: {
        status: {}
    }
}

const getters = {
    getGamificationData: state => state.gamification,
    //STATUSES
    getStatusesData: state => state.gamification.status,
    getStatusesList: state => state.gamification.status.lists,
    getStatusFoldersData: state => state.folders.status,
    //RATINGS
    getRatingsData: state => state.gamification.ratings,
    //TEAM COMPETITIONS
    getCompetitionsData: state => state.gamification.competitions,
    //REWARDS
    getRewardsOptionsData: state => state.gamification.rewards.options,
    getRewardsList: state => state.gamification.rewards.lists,

    //scores
    getScores: state => state.scores
}

const mutations = {
    SET_GAMIFICATION_DATA(state, data) {
        Object.assign(state.gamification, data)
    },
    //STATUSES
    SET_STATUS_OPTIONS_DATA(state, data) {
        Object.assign(state.gamification.status.options, data)
    },
    UPDATE_STATUSES_OPTIONS(state, data) {
        Object.assign(state.gamification.status.options, data)
    },
    SET_STATUSES(state, data) {
        state.gamification.status.lists = data
    },

    UPDATE_STATUS(state, { id, data }) {
        const index = state.gamification.status.lists.findIndex(status => status.folder_nodeble_id === id)
        if (index !== -1) {
            Object.assign(state.gamification.status.lists[index].folder_nodeble, data)
        }
    },
    SET_STATUS_FOLDERS_DATA(state, data) {
        Object.assign(state.folders.status, data)
    },

    //RATINGS
    SET_RATINGS_DATA(state, data) {
        state.gamification.ratings.is_enabled = data.is_enabled
        state.gamification.ratings.lists = data.data
    },
    SET_COMPETIONS_DATA(state, data) {
        state.gamification.competitions.lists = data.data
    },

    TOGGLE_RATINGS_STATUS(state, data) {
        state.gamification.ratings.is_enabled = data
    },
    ADD_RATING(state, data) {
        state.gamification.ratings.lists.unshift(data)
    },
    UPDATE_RATING(state, { id, data }) {
        const index = state.gamification.ratings.lists.findIndex(rating => rating.id === id)
        if (index !== -1) {
            state.gamification.ratings.lists.splice(index, 1, data)
        }
    },
    DELETE_RATING(state, id) {
        const index = state.gamification.ratings.lists.findIndex(rating => rating.id === id)
        if (index !== -1) {
            state.gamification.ratings.lists.splice(index, 1)
        }
    },
    //TEAM COMPETITIONS
    ADD_COMPETITION(state, data) {
        state.gamification.competitions.lists.unshift(data)
    },
    UPDATE_COMPETITION(state, { id, data }) {
        const index = state.gamification.competitions.lists.findIndex(competition => competition.id === id)
        if (index !== -1) {
            state.gamification.competitions.lists.splice(index, 1, data)
        }
    },
    DELETE_COMPETITION(state, id) {
        const index = state.gamification.competitions.lists.findIndex(competition => competition.id === id)
        if (index !== -1) {
            state.gamification.competitions.lists.splice(index, 1)
        }
    },

    //REWARDS
    SET_REWARDS_OPTION_DATA(state, data) {
        Object.assign(state.gamification.rewards.options, data)
    },
    SET_REWARDS_LIST(state, data) {
        state.gamification.rewards.lists = data
    },
    UPDATE_REWARDS_OPTIONS(state, data) {
        Object.assign(state.gamification.rewards.options, data)
    },

    //SCORES
    SET_SCORES(state, data) {
        state.scores = data
    }
}

const actions = {
    fetchGamificationData({ commit }) {
        return axios
            .get("gamification")
            .then(response => {
                commit("SET_GAMIFICATION_DATA", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },

    //STATUSES
    fetchStatusOptionsData({ commit }) {
        return axios
            .get("gamification/status-option")
            .then(response => {
                commit("SET_STATUS_OPTIONS_DATA", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    fetchStatusesFoldersData({ commit }, id = "root") {
        return axios
            .get(`folders/gamification-statuses/${id}?page=1&per_page=150`)
            .then(response => {
                commit("SET_STATUSES", response.data.data)
                commit("SET_STATUS_FOLDERS_DATA", { folders: response.data.folders, folder: response.data.folder })
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    fetchSelectedListData({ commit }, id = "root") {
        return axios
            .get(`folders/${id}?page=1&per_page=150`)
            .then(response => {
                commit("SET_STATUSES", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    updateStatusesOptions({ commit }, payload) {
        return axios
            .post("gamification/status-option", payload)
            .then(response => {
                commit("UPDATE_STATUSES_OPTIONS", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    createStatus({}, payload) {
        return axios.post("gamification/status", payload).catch(error => {
            return Promise.reject(error)
        })
    },
    deleteStatus({}, id) {
        return axios.delete(`gamification/status/${id}`).catch(error => {
            return Promise.reject(error)
        })
    },
    updateStatus({}, { id, payload }) {
        return axios.put(`gamification/status/${id}`, payload).catch(error => {
            return Promise.reject(error)
        })
    },
    createStatusGroup({}, payload) {
        return axios
            .post(`folders`, payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    deleteStatusGroup({}, id) {
        return axios
            .delete(`folders/${id}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    updateStatusGroup({}, { id, title }) {
        return axios
            .put(`folders/${id}`, { title: title })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    chaneStatusPosition({ commit }, { id, payload }) {
        return axios
            .put(`folders/${id}/change-position`, payload)
            .then(response => {
                commit("SET_STATUSES", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },

    //RATINGS
    fetchRatingsData({ commit }, params) {
        return axios
            .get("gamification/main-ratings", { params })
            .then(response => {
                commit("SET_RATINGS_DATA", response.data)
                return response
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    fetchCompetitionsData({ commit }, params) {
        return axios
            .get("gamification/main-competitions", { params })
            .then(response => {
                commit("SET_COMPETIONS_DATA", response.data)
                return response
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    toggleRatingsStatus({ commit }, payload) {
        return axios
            .post("gamification", payload)
            .then(() => commit("TOGGLE_RATINGS_STATUS", payload.is_rating_enabled))
            .catch(error => {
                return Promise.reject(error)
            })
    },
    createRating({ commit }, data) {
        return axios
            .post("gamification/ratings", data.payload)
            .then(response => {
                commit("ADD_RATING", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    updateRating({ commit }, { payload, id }) {
        return axios
            .put(`gamification/ratings/${id}`, payload)
            .then(response => {
                commit("UPDATE_RATING", { data: response.data.data, id })
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    deleteRating({ commit }, id) {
        return axios
            .delete(`gamification/ratings/${id}`)
            .then(() => {
                commit("DELETE_RATING", id)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },

    //TEAM COMPETITIONS
    createCompetition({ commit }, data) {
        return axios
            .post("gamification/competitions", data.payload)
            .then(response => {
                commit("ADD_COMPETITION", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    updateCompetition({ commit }, { payload, id }) {
        return axios
            .put(`gamification/competitions/${id}`, payload)
            .then(response => {
                commit("UPDATE_COMPETITION", { data: response.data.data, id })
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    deleteCompetition({ commit }, id) {
        return axios
            .delete(`gamification/competitions/${id}`)
            .then(() => {
                commit("DELETE_COMPETITION", id)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },

    //REWARDS
    fetchRewardsOptionData({ commit }) {
        return axios
            .get("gamification/reward-options")
            .then(response => {
                commit("SET_REWARDS_OPTION_DATA", response.data)
                return response
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    fetchRewardsList({ commit }, params) {
        return axios
            .get("gamification/rewards", { params })
            .then(response => {
                commit("SET_REWARDS_LIST", response.data.data)
                return response
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    updateRewardsOptions({ commit }, payload) {
        return axios
            .post("gamification/reward-options", payload)
            .then(response => {
                commit("UPDATE_REWARDS_OPTIONS", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    },
    createReward({}, payload) {
        return axios.post("gamification/rewards", payload).catch(error => {
            return Promise.reject(error)
        })
    },
    updateReward({}, { id, payload }) {
        return axios.put(`gamification/rewards/${id}`, payload).catch(error => {
            return Promise.reject(error)
        })
    },
    chaneRewardPosition({ commit }, { payload, id }) {
        return axios
            .put(`gamification/rewards/${id}/order`, payload)
            .then(response => {
                commit("SET_REWARDS_LIST", response.data.data)
            })
            .catch(error => {
                return Promise.reject(error)
            })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
